export { default as SingleColorSelector } from './SingleColorSelector';



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleColorSelector/index.ts